<template>
  <div>
    <top-bar :back="true"/>
    <div class="w3-main" style="margin-top:50px;margin-left: 300px">
      <header class="w3-container w3-cell-row w3-margin-bottom w3-small" style="padding-top:22px">
        <h6><b>Pagamentos Pendentes</b></h6>
      </header>
      <div class="w3-container w3-margin-top">
        <div class="w3-white w3-responsive" style="margin-bottom: 80px; min-height: 50vh">
          <table class="w3-table w3-bordered w3-centered w3-small">
            <tr class="primary">
              <th class="w3-left-align">Cliente</th>
              <th>Pagamento</th>
              <th>Valor</th>
              <th>Data</th>
              <th style="width: 30%">Observações</th>
              <th style="width: 120px">&nbsp;#</th>
            </tr>
            <tr v-for="p in pagamentos">
              <td class="w3-left-align">{{p.nome}}</td>
              <td>{{p.nome_pagamento}}</td>
              <td><b>R$ {{p.valor_total * (-1) | valor}}</b></td>
              <td>{{p.dt_pagamento}}</td>
              <td>{{p.observacao}}</td>
              <td>
                <button class="w3-button primary" v-show="p.status !== '1'" @click="aprovarPagamento(p)"><i class="fa fa-check"></i></button>
                <button class="w3-button w3-border" v-show="p.status !== '3'" @click="removerPagamento(p)"><i class="fa fa-times"></i></button>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import TopBar from "../../commons/TopBar.vue"

  export default {
    components: {TopBar},

    data() {
      return {
        token: '',
        pagamentos: [],
      }
    },

    methods: {
      buscarPagamentos() {
        openLoading("Buscando Pagamentos");

        this.$http.get(base_url + 'transacoes/pagamentos/pendentes/' + this.token)
          .then(response => {
            this.pagamentos = response.data;
            closeLoading();

          }, res => {
            console.log(res);
            closeLoading();
            openModalMsg(res.data.result, res.data.msg, true);
          });
      },

      removerPagamento(p) {
        openLoading("Removendo Pagamento");
        this.$http.post(base_url + 'transacoes/remover-pagamento/' + this.token, p, {emulateJSON: true})
          .then(response => {
            closeLoading();

            if (response.data.result && response.data.result  === 'success') {
              this.buscarPagamentos();
            }

          }, res => {
            closeLoading();
            console.log(res);
            openModalMsg(res.data.result, res.data.msg);
          });
      },

      aprovarPagamento(p) {
        openLoading("Enviando Pagamento");
        this.$http.post(base_url + 'transacoes/aprovar-pagamento/' + this.token, p, {emulateJSON: true})
          .then(response => {
            closeLoading();
            console.log(response);

            if (response.data.result && response.data.result  === 'success') {
              this.buscarPagamentos();
            }

          }, res => {
            closeLoading();
            console.log(res);
            openModalMsg(res.data.result, res.data.msg);
          });
      },

    },

    mounted() {
      this.token = localStorage.getItem('key');
      this.buscarPagamentos();
    },

    filters: {
      valor(value) {
        if (value !== null && value !== undefined) {
          return parseFloat(value).toFixed(2);
        } else {
          return parseFloat('0').toFixed(2);
        }
      }
    }
  }
</script>

<style scoped>
  .w3-table tr td {
    padding: 13px;
    text-align: center;
  }

  .w3-table td {
    vertical-align: middle;
    white-space: nowrap;
  }
</style>



// WEBPACK FOOTER //
// src/components/admin/comanda/AdminPagamentos.vue